// prettier-disable-next-line
import {
  addIdToData
} from "@/utils/helpers.js";
import stops from "./stops";

const sections = [{
  text: {
    title: {
      en: `Welcome to Gabrielle Chanel. Fashion Manifesto.`
    }
  },
  stops: [...stops.slice(0, 17)]
}];

export default addIdToData(sections);